const item =[
    {
        id:1,
        img:'image/Coding.gif',
        title:'Programming principle',
        url: 'programming'

    },
    
    {
        id:2,
        img:'image/website.gif',
        title: 'Website',
        url: 'website'
    },

    {
        id:3,
        img:'image/design.gif',
        title: 'Design',
        url: 'design'
    },

    {
        id:4,
        img:'image/application.gif',
        title: 'Application',
        url: 'application'
    },
    
    {
        id:5,
        img:'image/network.gif',
        title: 'Networking',
        url: 'networking'
    },
     
    {
        id:6,
        img:'image/office.svg',
        title: 'Microsoft Office',
        url: 'msoffice'
    },
    
    {
        id:7,
        img:'image/database1.gif',
        title: 'Database',
        url: 'database'
    },

    {
        id:8,
        img:'image/arduino.png',
        title: 'Arduino',
        url : 'arduino'
    },

    {
        id:9,
        img:'image/hardware.png',
        title: 'ئاشنابە بە هەموو پارچەکانی کۆمپیوتەرەکەت',
        url : 'hardware'
    },

];


export default item;